import { StrictLocalizeFunction } from "../localization";

import { CANADA_PROVINCE_SHORTHAND_TO_NAME } from "./CANADA_PROVINCE_SHORTHAND_TO_NAME";
import { US_STATE_SHORTHAND_TO_NAME } from "./US_STATE_SHORTHAND_TO_NAME";

export const STATE_PROVINCE_SHORTHAND_TO_NAME = (
  strictLocalize: StrictLocalizeFunction
) =>
  ({
    ...US_STATE_SHORTHAND_TO_NAME(strictLocalize),
    ...CANADA_PROVINCE_SHORTHAND_TO_NAME(strictLocalize),
  } as const);
